import request from '../utils/request'

const baseURL = process.env.VUE_APP_BASE_API || 'https://nadc.china-vo.org/galaxycircus'
const STREAM_NOT_SUPPORTED_MESSAGE = '浏览器不支持流式响应'

const buildStreamHeaders = () => ({
  'Content-Type': 'application/json',
  'Token-Circus': window.localStorage.getItem('Token-Circus') || '',
  'Unique-Ident': window.localStorage.getItem('umtId') || '',
})

const emitEvent = (onEvent, payload) => {
  if (typeof onEvent === 'function') {
    onEvent(payload)
  }
}

const parseSseEvent = (rawEvent) => {
  const dataLines = rawEvent
    .split('\n')
    .filter((line) => line.startsWith('data:'))
    .map((line) => line.slice(5).trimStart())

  if (!dataLines.length) {
    return null
  }

  const dataText = dataLines.join('\n').trim()
  if (!dataText) {
    return null
  }

  try {
    return JSON.parse(dataText)
  } catch (e) {
    return { type: 'chunk', content: dataText }
  }
}

const consumeSseResponse = async (response, onEvent) => {
  if (!response.body) {
    throw new Error(STREAM_NOT_SUPPORTED_MESSAGE)
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder('utf-8')
  let buffer = ''

  const flushBuffer = () => {
    let eventEnd
    while ((eventEnd = buffer.indexOf('\n\n')) !== -1) {
      const rawEvent = buffer.slice(0, eventEnd).trim()
      buffer = buffer.slice(eventEnd + 2)
      if (!rawEvent) {
        continue
      }

      const payload = parseSseEvent(rawEvent)
      if (payload) {
        emitEvent(onEvent, payload)
      }
    }
  }

  while (true) {
    const { value, done } = await reader.read()
    if (done) {
      break
    }

    buffer += decoder.decode(value, { stream: true })
    buffer = buffer.replace(/\r\n/g, '\n')
    flushBuffer()
  }

  const tail = decoder.decode()
  if (tail) {
    buffer += tail
  }
  buffer = buffer.replace(/\r\n/g, '\n')
  flushBuffer()
}

const extractStreamErrorMessage = async (response) => {
  const errorText = await response.text().catch(() => '')
  const raw = (errorText || '').trim()
  if (!raw) {
    return `HTTP ${response.status}`
  }

  try {
    const json = JSON.parse(raw)
    return json.message || json.detail || raw
  } catch (e) {
    // keep fallback path
  }

  const ssePayload = parseSseEvent(raw.replace(/\r\n/g, '\n'))
  if (ssePayload && typeof ssePayload === 'object') {
    return ssePayload.message || ssePayload.detail || ssePayload.content || raw
  }

  return raw.replace(/^data:\s*/i, '')
}

const postSse = async (path, data, onEvent) => {
  const response = await fetch(`${baseURL}${path}`, {
    method: 'POST',
    headers: buildStreamHeaders(),
    body: JSON.stringify(data || {}),
  })

  if (!response.ok) {
    const message = await extractStreamErrorMessage(response)
    throw new Error(message)
  }

  await consumeSseResponse(response, onEvent)
}

// 星系分析：生成 session_id 与科学总结
export const galaxyAnalyze = data => request({
  method: 'post',
  url: '/api/galaxy/analyze',
  timeout: 30000,
  data,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') },
})

// 星系流式分析（SSE over POST）
export const galaxyAnalyzeStream = async (data, onEvent) => {
  await postSse('/api/galaxy/analyze/stream', data, onEvent)
}

// 星系对话：必须携带 analyze 返回的 sessionId
export const galaxyChat = data => request({
  method: 'post',
  url: '/api/galaxy/chat',
  data,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') },
})

// 星系流式对话（SSE over POST）
export const galaxyChatStream = async (data, onEvent) => {
  await postSse('/api/galaxy/chat/stream', data, onEvent)
}
